module.exports = __webpack_public_path__ + "static/media/background.a51a7f95.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qci/sprites/gameOceanCleanup/background.png
// module id = 2555
// module chunks = 0